module.exports = __webpack_public_path__ + "7e62d24c027dd31940f136a7e55f45bd.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/cetabever/enlflx.png
// module id = 2412
// module chunks = 0